var map = {
	"./circle1.svg": 40204,
	"./circle2.svg": 95551,
	"./circle3.svg": 90798,
	"./circle4.svg": 16145,
	"./circle5.svg": 53344,
	"./cube.svg": 94252,
	"./dots1.svg": 81956,
	"./dots2.svg": 86551,
	"./dots3.svg": 23750,
	"./dots4.svg": 50633,
	"./loader.gif": 86981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88279;